module.exports = __webpack_public_path__ + "static/img/peopleGame4.c6d8514.webp";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/peopleGame4.webp
// module id = BS0g
// module chunks = 3